const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export const randomString = function (length) {
  let alphabet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CHARS;
  let str = '';

  for (let i = 0; i < length; ++i) {
    str += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
  }

  return str;
};
//# sourceMappingURL=randomstring.js.map